var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number)?_c('div',{staticClass:"distributor-rating-card",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.formattedImagePath,"alt":"avatar"}}),_c('p',[_vm._v("Ваше место в рейтинге")]),_c('mark',[_vm._v(_vm._s(_vm.number))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }